import Vue from 'vue';
import Router from 'vue-router';
import * as stores from '@/stores/index';
import exhibitor from '@/router/exhibitor/index';
import admin from '@/router/admin';
import buyer from '@/router/buyer';
import root from '@/router/root';
import { auths, actors } from '@/router/options';

// import buyerM from '@/modules/buyer/buyer';
import {
  buyer as buyerM,
} from 'mostra';

import authRouters from '@/router/auth/index';

Vue.use(Router);

// const { auth, actor } = options;

const defaultRouters: any[] = [];
const routes: any[] = defaultRouters
  .concat(admin.routes)
  .concat(authRouters.routes)
  .concat(exhibitor.routes)
  .concat(buyer.routes)
  .concat(root.routes)
  .concat([
    {
      path: '*',
      component: {
        template: '<div></div>',
        created() {
          window.location.href = '/ssr/';
        },
      },
    },
  ]);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// 認証を確認する関数
const confrimActor = (to: any, next: () => void) => {
  // adminのみ遷移し、admin権限を持たない場合アクセスできずサインイン画面に飛ばされる
  if (to.meta.actor) {
    if (to.meta.actor === actors.admin) {
      if (!stores.auth.state.admin) {
        window.location.href = '/';
      }
    } else if (to.meta.actor === actors.buyer) {
      if (!stores.auth.state.isBuyer) {
        window.location.href = '/web/auth/signin';
      }
    } else if (to.meta.actor === actors.exhibitor) {
      if (!stores.auth.state.isExhibitor) {
        window.location.href = '/web/auth/signin';
      }
    }
  }
  next();
};

// // IEかどうかをチェックする関数
// const isIeCheck = (to: any) => {
//   const toPath = to.path;
//   // IE警告ページに遷移する場合はIEであると判定
//   if (toPath.match(/error-ie/)) {
//     return true;
//   }
//   const ua = navigator.userAgent;
//   // UAが取れない場合はIEではないと判定
//   if (!ua) return false;
//   const userAgent = ua.toLowerCase();
//   // UAがIEでない場合
//   if (userAgent.indexOf('msie') === -1 && userAgent.indexOf('trident') === -1) {
//     return false;
//   }
//   // UAがIEである場合
//   return true;
// };

router.beforeEach((to: any, from: any, next) => {
  const { auth } = to.meta;
  const { isAnonymous, isBuyer, isExhibitor } = stores.auth.state;
  // const isIe = isIeCheck(to);
  // if (isIe) {
  //   // IEエラーページに遷移
  //   if (to.path.match(/error-ie/)) {
  //     next();
  //   }
  //   if (!to.path.match(/error-ie/)) {
  //     window.location.href = '/web/error-ie';
  //   }
  // }
  if (to.path === '/linking' || from.path === 'linking') {
    next();
  }

  if (auth && auth === auths.required) {
    if (isAnonymous) {
      window.location.href = '/web/auth/signin';
    } else {
      confrimActor(to, next);
    }
  } else if (auth && auth === auths.noRequired) {
    if (isAnonymous) {
      next();
    } else {
      if (isBuyer) {
        window.location.href = '/web/buyer/setting/userinfo';
      }
      if (isExhibitor) {
        window.location.href = '/web/exhibitor/brand';
      }
    }
  } else {
    next();
  }
});

router.beforeEach(async (to: any, from: any, next) => {
  const { auth } = to.meta;
  const { isBuyer, uid } = stores.auth.state;
  // const isIe = isIeCheck(to);
  // if (isIe) {
  //   // IEエラーページに遷移
  //   if (to.path.match(/error-ie/)) {
  //     next();
  //   }
  //   if (!to.path.match(/error-ie/)) {
  //     window.location.href = '/web/error-ie';
  //   }
  // }
  // if (!isIe) {
  // }
  if (to.path === '/linking' || from.path === 'linking') {
    next();
  }

  if (auth && auth === auths.required) {
    if (isBuyer && to.name !== 'auth-register') {
      const user = await buyerM.load(uid);
      if (user && !user.data.isCompleted) {
        window.location.href = '/web/auth/register?re=1';
      }
    }
  }
  next();
});

const appName = 'Granstra';

router.afterEach((to: any, from: any) => {
  console.log(`from:${from.path},to:${to.path}`);
  if (to.meta.title) {
    const { title } = to.meta;
    document.title = `${title} | ${appName}`;
  }
});

export default router;
